export default {
  // Pixels Management
  "pixelsManagement.add": "添加",
  "pixelsManagement.details": "详情",
  "pixelsManagement.edit": "编辑",
  "pixelsManagement.delete": "删除",
  "pixelsManagement.delete.confirm.title": "删除配置",
  "pixelsManagement.delete.confirm.content": "确定要删除这个配置吗？",
  "pixelsManagement.delete.confirm.okText": "确定",
  "pixelsManagement.delete.confirm.cancelText": "取消",
  "pixelsManagement.modal.title": "像素管理配置",
  "pixelsManagement.thead.createdAt": "创建时间",
  "pixelsManagement.thead.updatedAt": "更新时间",
  "pixelsManagement.thead.action": "操作",

  // Pixel fields
  "pixelsManagement.thead.id": "ID",
  "pixelsManagement.thead.documentId": "文档ID",
  "pixelsManagement.thead.pixelId": "像素ID",
  "pixelsManagement.thead.providerType": "提供商类型",
  "pixelsManagement.thead.initInChannel": "渠道初始化",
  "pixelsManagement.thead.initToApp": "应用初始化",
  "pixelsManagement.thead.pwaStartUrl": "PWA启动地址",
  "pixelsManagement.thead.testEventCode": "测试事件代码",
  "pixelsManagement.thead.accessToken": "访问令牌",
  "pixelsManagement.thead.remark": "备注",
  "pixelsManagement.thead.bindSite": "绑定站点",
  "pixelsManagement.thead.title": "标题",
  "pixelsManagement.thead.key": "键",
  "pixelsManagement.thead.groupKey": "分组键",
  "pixelsManagement.thead.sort": "排序",
  "pixelsManagement.thead.other": "其他",
  "pixelsManagement.thead.createdBy": "创建者",
  "pixelsManagement.thead.updatedBy": "更新者",
};

